// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610150635/js/" + chunkId + "." + {"44":"1ccfa8b8","225":"27894145","481":"3d409ee8","486":"011557fb","770":"e65d659f"}[chunkId] + ".0.6124952565189835.chunk.js";
};